import { elevate, localStorageBackedSession } from '@apptus/esales-api';

export const getLocalisedElevate = (): ReturnType<typeof elevate> => {
    if (!window.location.origin.includes('eu.motelrocks.com')) {
        return window.elevate;
    }

    const hostname = window.location.hostname;

    const clusterId = 'wD79D90F4';

    switch (hostname) {
        case 'eu.motelrocks.com':
            return elevate({
                clusterId,
                touchpoint: window.innerWidth < 768 ? 'mobile' : 'desktop',
                session: localStorageBackedSession(),
                locale: 'en-150',
                market: 'EU',
            });
        case 'fr.eu.motelrocks.com':
            return elevate({
                clusterId,
                touchpoint: window.innerWidth < 768 ? 'mobile' : 'desktop',
                session: localStorageBackedSession(),
                locale: 'fr-FR',
                market: 'EU',
            });
        case 'de.eu.motelrocks.com':
            return elevate({
                clusterId,
                touchpoint: window.innerWidth < 768 ? 'mobile' : 'desktop',
                session: localStorageBackedSession(),
                locale: 'de-DE',
                market: 'EU',
            });
        case 'es.eu.motelrocks.com':
            return elevate({
                clusterId,
                touchpoint: window.innerWidth < 768 ? 'mobile' : 'desktop',
                session: localStorageBackedSession(),
                locale: 'es-ES',
                market: 'EU',
            });
        case 'it.eu.motelrocks.com':
            return elevate({
                clusterId,
                touchpoint: window.innerWidth < 768 ? 'mobile' : 'desktop',
                session: localStorageBackedSession(),
                locale: 'it-IT',
                market: 'EU',
            });
        case 'nl.eu.motelrocks.com':
            return elevate({
                clusterId,
                touchpoint: window.innerWidth < 768 ? 'mobile' : 'desktop',
                session: localStorageBackedSession(),
                locale: 'nl-NL',
                market: 'EU',
            });
        default:
            return window.elevate;
    }
};

export const resetElevateSessionIfTrackingConsentDenied = () => {
    // @ts-expect-error Tracking consent not defined on window.Shopify
    if (window.Shopify?.trackingConsent?.userCanBeTracked()) {
        return;
    }

    try {
        // @ts-expect-error Type for window.elevate.notify.c is not defined.
        window?.elevate?.notify?.c?.session.reset();
    } catch(e) {
        window.console.error(e);
    }

};
